import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  /c/10495/sooduspakkumised

  <span style="color:#85c1dc;">**FI:**</span>
  /prods/interior/onsale

  <span style="color:#85c1dc;">**RU:**</span>
  /prods/interior/onsale
*/
/* @__NO_SIDE_EFFECTS__ */
const m845 = msg(
  mf`/c/10495/sooduspakkumised`,
  mf`/prods/interior/onsale`,
  mf`/prods/interior/onsale`,
)

export { m845 as 'w.basket.empty.second.link' }